module.exports = __webpack_public_path__ + "media/images/flags/GB-SCT-48ee9ce6b05882a0fa3bb3624e7a4efa.svg";